export enum Progress {
  COMPLETE = 'COMPLETE',
  CURRENT = 'CURRENT',
  FUTURE = 'FUTURE',
}

export function getProgress(startDate?: string, endDate?: string) {
  if (!startDate) return Progress.FUTURE;
  const now = new Date();
  const start = new Date(startDate);
  if (now < start) return Progress.FUTURE;
  if (!endDate) return Progress.CURRENT;
  const end = new Date(endDate);
  if (now > end) return Progress.COMPLETE;
  return Progress.CURRENT;
}
